import React from "react";
import AcxChip from "./AcxChip";
import { Tooltip } from "@mui/material";

interface OwnProps {
    values?: string[];
    size: "small" | "medium";
    color: "green" | "red" | "blue" | "gray";
    height?: string;
    toolTip?: React.ReactNode;
    maxWidth?: string;
    multiToolTip?: boolean;
}

const AcxChipList = (props: OwnProps) => {
    const getStyle = () => {
        if (props.height) {
            return { width: "100%", height: props.height, overflow: "hidden" };
        }
        if (props.maxWidth) {
            return {
                width: "100%",
                maxWidth: props.maxWidth,
                overflow: "hidden",
            };
        }
        return { width: "100%", overflow: "hidden" };
    };

    return (
        <Tooltip title={props.toolTip ?? ""}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    ...getStyle(),
                }}
            >
                {props.values?.map((value, index) => {
                    return (
                        <div
                            key={`${value}_${index}`}
                            style={{
                                flexShrink: 1,
                                overflow: "hidden",
                                marginRight: "5px",
                            }}
                        >
                            <AcxChip
                                key={value}
                                size={props.size}
                                color={props.color}
                                label={value}
                                multiToolTip={props.multiToolTip}
                            />
                        </div>
                    );
                })}
            </div>
        </Tooltip>
    );
};

export default AcxChipList;
